import { useMemo, useState } from 'react';
import Navbar from '@/components/help-center/Navbar';
import Footer from '@/components/help-center/Footer';
import { AceCard } from '@/components/help-center/aces/AceCard';
import { AceHero } from '@/components/help-center/aces/AceHero';
import { AcesFilterBar } from '@/components/help-center/aces/AcesFilterBar';
import { AcesWhatSection } from '@/components/help-center/aces/AcesWhatSection';
import { useCatalogAces } from '@/components/painel/aces/aces-cms-context';
import {
  computeAceListingStats,
  filterAndSortAces,
  type AceFilterId,
  type AceSortId,
} from '@/lib/aces-data';

export default function AcesPage() {
  const { aces } = useCatalogAces();
  const [query, setQuery] = useState('');
  const [filter, setFilter] = useState<AceFilterId>('all');
  const [sort, setSort] = useState<AceSortId>('recent');

  const listingStats = useMemo(() => computeAceListingStats(aces), [aces]);

  const filteredAces = useMemo(
    () => filterAndSortAces(aces, { query, filter, sort }),
    [aces, query, filter, sort]
  );

  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <AceHero variant="listing" listingStats={listingStats} />
        <AcesWhatSection />
        <section className="bg-gray-50 px-6 py-14 md:py-16">
          <div className="mx-auto max-w-7xl space-y-8">
            <header>
              <span className="mb-3 inline-flex rounded-full border border-indigo-200 bg-indigo-50 px-3 py-1 font-poppins text-[11px] font-semibold uppercase tracking-wide text-indigo-800">
                Catálogo
              </span>
              <h2 className="font-poppins text-2xl font-bold text-gray-900 md:text-3xl">
                Todos os Aces
              </h2>
            </header>
            <AcesFilterBar
              query={query}
              onQueryChange={setQuery}
              filter={filter}
              onFilterChange={setFilter}
              sort={sort}
              onSortChange={setSort}
              resultCount={filteredAces.length}
            />
            {filteredAces.length > 0 ? (
              <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3">
                {filteredAces.map((ace) => (
                  <AceCard key={ace.slug} ace={ace} />
                ))}
              </div>
            ) : (
              <div className="rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-16 text-center">
                <p className="font-poppins text-lg font-semibold text-gray-800">
                  Nenhum Ace encontrado
                </p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
